var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoalitionsIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 4H4V25.5578H26V4Z",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0227 4.39062V10.2346C16.0227 11.0138 15.3832 11.6631 14.6158 11.6631H13.4646C12.6972 11.6631 12.0576 12.3125 12.0576 13.0917V16.8578C12.0576 17.637 12.6972 18.2863 13.4646 18.2863H14.6158C15.3832 18.2863 16.0227 18.9356 16.0227 19.7148V25.5588",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoalitionsIcon);
export default __webpack_public_path__ + "static/media/coalitions_icon.c8df6d8828a74d5675caa0a8b4e8da45.svg";
export { ForwardRef as ReactComponent };